import React from 'react';
import { Helmet } from 'react-helmet';

const SchemaMarkup = () => {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Quick Inbox - Temporary Email Service",
    "url": "https://quick-inbox.com",
    "description": "Free temp mail service providing temporary and disposable email addresses. Protect your privacy and avoid spam with our easy-to-use service."
  };

  const webAppSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Quick Inbox Temp Mail",
    "url": "https://quick-inbox.com",
    "description": "Create free temporary email addresses instantly with our temp mail service. Protect your privacy, avoid spam, and keep your real inbox clean with disposable email addresses.",
    "applicationCategory": "UtilityApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "alternativeName": ["Temporary Email Service", "Disposable Email Provider", "Temp Mail Generator"]
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Quick Inbox",
    "url": "https://quick-inbox.com",
    "logo": "https://quick-inbox.com/logo64.png"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(webAppSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;